const CONTEXT_MENU_DISABLER = (event) => {
  event.preventDefault();
  return false;
};
export class CoreDomUtils {
  static disableContextMenu() {
    document.addEventListener("contextmenu", CONTEXT_MENU_DISABLER);
  }
  static reEstablishContextMenu() {
    document.removeEventListener("contextmenu", CONTEXT_MENU_DISABLER);
  }
  static isHTMLVideoElementLoaded(videoElement) {
    return videoElement.readyState === 4;
  }
}
export function observeStyleChange(element) {
  const Observe = (element2, opt, cb) => {
    const Obs = new MutationObserver((m) => [...m].forEach(cb));
    Obs.observe(element2, opt);
  };
  Observe(element, {
    attributesList: ["style"],
    attributeOldValue: true
  }, (m) => {
    console.log("m");
    console.warn(m);
  });
}
